var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty2Dark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-svgs-path": "theme_dark/project_new.svg",
    viewBox: "0 0 220 200",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2550 -240)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Project"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1800-100h300v300h-300z",
    transform: "matrix(.73333 0 0 .66667 1230 306.667)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.63443 0 0 .69858 -7340.619 -210.406)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M15684.8 780h160v120h-160z"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15684.8 780h160v120h-160z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 1.23,
    transform: "matrix(.5418 -.69624 .5418 .69624 14740.5 333.948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 1.23,
    transform: "matrix(.5418 -.69624 .5418 .69624 14755.1 333.948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 1.23,
    transform: "matrix(.5418 -.69624 .5418 .69624 14769.6 333.948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 1.23,
    transform: "matrix(.5418 -.69624 .5418 .69624 14784.1 333.948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 1.23,
    transform: "matrix(.5418 -.69624 .5418 .69624 14798.7 333.948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 1.23,
    transform: "matrix(.5418 -.69624 .5418 .69624 14813.2 333.948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 1.23,
    transform: "matrix(.5418 -.69624 .5418 .69624 14827.8 333.948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 1.23,
    transform: "matrix(.5418 -.69624 .5418 .69624 14842.3 333.948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 1.23,
    transform: "matrix(.5418 -.69624 .5418 .69624 14856.9 333.948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 1.23,
    transform: "matrix(.5418 -.69624 .5418 .69624 14871.4 333.948)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 1.23,
    transform: "matrix(.5418 -.69624 .5418 .69624 14886 333.948)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 1.23,
    transform: "scale(1.15298 .69584) rotate(45 7230.737 17078.721)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 1.23,
    transform: "scale(1.15298 .69584) rotate(45 7207.816 17088.215)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 1.23,
    transform: "scale(1.15298 .69584) rotate(45 7184.896 17097.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 1.23,
    transform: "scale(1.15298 .69584) rotate(45 7161.975 17107.203)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 1.23,
    transform: "scale(1.15298 .69584) rotate(45 7139.054 17116.697)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 1.23,
    transform: "scale(1.15298 .69584) rotate(45 7116.134 17126.191)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 1.23,
    transform: "matrix(.81528 .49203 -.81528 .49203 16365.8 2.273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 1.23,
    transform: "scale(1.15298 .69584) rotate(45 7070.293 17145.18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 1.23,
    transform: "scale(1.15298 .69584) rotate(45 7047.372 17154.673)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 1.23,
    transform: "scale(1.15298 .69584) rotate(45 7024.451 17164.167)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 1191l-101 101",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 1.23,
    transform: "scale(1.15298 .69584) rotate(45 7001.53 17173.661)"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#404040",
    strokeWidth: 3,
    d: "M15684.8 780h160v120h-160z",
    transform: "matrix(.63443 0 0 .69858 -7340.619 -210.406)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: 5.65,
    d: "M15684.8 780h160v120h-160z",
    transform: "matrix(.35915 -.03543 .03405 .3452 -3083.49 604.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15821.8 748c-3.4 0-6.5-1.779-8.3-4.682-3.6-6.189-9.7-16.318-9.7-16.318l4.1-.234 11.6 10.234h44.9c5.9 0 11.3 3.023 14.4 8-3.3 1.964-7.1 3-11 3h-46z",
    fill: "#fff",
    transform: "matrix(.58151 -.26229 .26229 .58151 -6798.068 4064.072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15779 760.964l-1.8 32.631 5.6 1.144 5.6-20.173",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.25,
    transform: "matrix(.77417 -.34918 -.49414 -.47587 -9231.203 6214.983)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15761.1 770.276l-.1 2.006",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 4.08,
    transform: "matrix(.6164 -.27803 -.39344 -.3789 -6798.878 5012.573)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15761.1 770.276l-.1 2.006",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 4.08,
    transform: "matrix(.6164 -.27803 -.39344 -.3789 -6803.208 5014.683)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15761.1 770.276l-.1 2.006",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 4.08,
    transform: "matrix(.6164 -.27803 -.39344 -.3789 -6794.518 5010.703)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15761.1 770.276l-.1 2.006",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 4.08,
    transform: "matrix(.6164 -.27803 -.39344 -.3789 -6790.178 5008.963)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15761.1 770.276l-.1 2.006",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 4.08,
    transform: "matrix(.6164 -.27803 -.39344 -.3789 -6811.898 5018.523)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15761.1 770.276l-.1 2.006",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 4.08,
    transform: "matrix(.6164 -.27803 -.39344 -.3789 -6807.558 5016.783)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: 2.52,
    d: "M15787.8 921h11v9h-11z",
    transform: "matrix(.71106 0 0 .86907 -8605.822 -400.402)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15840 823.856c.5-.698 1.1-1.351 1.7-1.911 6.4-5.324 11.3 2.485 11 8.634-.2 5.801-3.3 9.438-7.4 12.529",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 1.81,
    transform: "translate(-14784.835 -586.872) scale(1.10557)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15844.8 756.634V780h-160v54.171c0 17.459 8.5 34.203 23.5 46.548 15 12.345 35.3 19.281 56.5 19.281 0 0 0 0 0 0 21.3 0 41.6-6.936 56.6-19.281 15-12.345 23.4-29.089 23.4-46.548v-77.537z",
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: 8.51,
    transform: "matrix(.21131 0 0 .25679 -620.854 131.706)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15767.1 900s0 0 0 0c42.9 0 77.7-24.096 77.7-53.821V780",
    fill: "none",
    stroke: "#797979",
    strokeWidth: 7.26,
    transform: "matrix(-.22169 0 0 .32021 6206.301 74.624)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18628.944 -777.812) scale(1.34826)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15827.3,
    cy: 817.5,
    r: 12.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15827.3,
    cy: 817.5,
    r: 12.5
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15827.3,
    cy: 817.5,
    r: 12.5,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.48,
    transform: "translate(0 12.5)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 15827.3,
    cy: 817.5,
    r: 12.5,
    fill: "none",
    stroke: "#797979",
    strokeWidth: 1.48
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15832.4 728.72c11.5 4.673 19 15.651 13.8 28.118-1.6 3.94-4.3 8.309-8.9 9.243-9.9 2.029-9.7-13.216.2-9.824 1.3.46 2.5 1.217 3.6 2.117 1.4 1.111 2.4 2.597 3.1 4.198 3.5 8.404-3 14.033-7 20.416-2.8 4.582-4.4 10.496-4.3 15.928",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 2.07,
    transform: "matrix(.99532 0 0 .94039 -13046.132 -434.105)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15807.6 726.151c-10.3 11.972-14 27.991-8.2 43.039 1.7 4.446 5.2 7.571 7.3 11.748",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 2.07,
    transform: "matrix(.99532 0 0 .94039 -13029.532 -438.642)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15739.5 990.429c7 1.038 14.3.248 21.4.334",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 2.3,
    transform: "matrix(.86907 0 0 .86907 -11046.227 -455.587)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15739.5 990.429c7 1.038 14.3.248 21.4.334",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 2.3,
    transform: "matrix(.86907 0 0 .86907 -11046.227 -449.478)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: 19.43,
    d: "M15684.8 780h160v120h-160z",
    transform: "matrix(.08732 0 0 .11643 1208.44 305.02)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15739.5 990.429c7 1.038 14.3.248 21.4.334",
    fill: "none",
    stroke: "#797979",
    strokeWidth: 2.3,
    transform: "matrix(.86907 0 0 .86907 -11096.627 -460.982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15739.5 990.429c7 1.038 14.3.248 21.4.334",
    fill: "none",
    stroke: "#797979",
    strokeWidth: 2.3,
    transform: "matrix(.86907 0 0 .86907 -11096.727 -455.596)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: 19.43,
    d: "M15684.8 780h160v120h-160z",
    transform: "matrix(.08732 0 0 .11643 1366.168 280.92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15739.5 990.429c7 1.038 14.3.248 21.4.334",
    fill: "none",
    stroke: "#797979",
    strokeWidth: 2.3,
    transform: "matrix(.86907 0 0 .86907 -10938.927 -485.09)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15739.5 990.429c7 1.038 14.3.248 21.4.334",
    fill: "none",
    stroke: "#797979",
    strokeWidth: 2.3,
    transform: "matrix(.86907 0 0 .86907 -10939.027 -479.703)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: 7.17,
    d: "M15684.8 780h160v120h-160z",
    transform: "matrix(.25798 .07098 -.07685 .27931 -1289.306 -937.996)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15831.8 988v10l7.1-7.071-7.1 7.071h10-10l7.1 7.07-7.1-7.07v10-10l-7 7.07 7-7.07h-10 10l-7-7.071 7 7.071v-10z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2.68,
    transform: "translate(-15012.936 -701.824) scale(1.11966)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15825.8,
    cy: 996,
    r: 3,
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: 3.45,
    transform: "translate(-6456.077 -161.366) scale(.57938)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: 15.62,
    d: "M15684.8 780h160v120h-160z",
    transform: "matrix(.10863 0 0 .14485 857.67 257.66)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18067.6 1376.14c.2.67 3.4 3.86 3.4 3.86l8.3-8.55",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.48,
    strokeLinejoin: "miter",
    transform: "translate(-21828.351 -1480.482) scale(1.35034)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: 15.62,
    d: "M15684.8 780h160v120h-160z",
    transform: "matrix(.10863 0 0 .14485 951.101 194.521)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18067.6 1376.14c.2.67 3.4 3.86 3.4 3.86l8.3-8.55",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.48,
    strokeLinejoin: "miter",
    transform: "translate(-21734.95 -1543.618) scale(1.35034)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15800.4 868.603l-36.7-30.682-37.6 30.682v30.508h74.3v-30.508z",
    fill: "#797979",
    fillOpacity: 0.75,
    transform: "matrix(.62358 0 0 .60166 -7168.496 -150.771)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty2Dark);
export default __webpack_public_path__ + "static/media/empty-2-dark.5711645369e6bc76f69a2cb36b1675fa.svg";
export { ForwardRef as ReactComponent };